export default {
  dropdownSkills: state => {
    return state.skills.map(skill => ({
      text: skill.name,
      value: skill.id.toString(),
      category: skill.category
    })).sort((a, b) => (a.text > b.text) ? 1 : ((b.text > a.text) ? -1 : 0))
  },
  dropdownFeaturedSkills: state => {
    return state.skills.filter(skill => skill.featured).map(skill => ({
      text: skill.name,
      value: skill.id.toString()
    })).sort((a, b) => (a.text > b.text) ? 1 : ((b.text > a.text) ? -1 : 0))
  },
  allSkills: state => {
    return state.skills
  },
  allGeneralSkills: state => {
    return state.skills.filter(skill => skill.category == 'כללי')
  }
}
